import WeeklyTimeslotDisplay from "./weeklyTimeslotDisplay";

export default WeeklyTimeslotDisplay;